import "./../App.css";
import CareerPanel from "./homePartials/career-panel";
import GamingPanel from "./homePartials/gaming-panel";
import ExperiencesPanel from "./homePartials/collections-panel";

function Home() {
  return (
    <div >
      <div className="App container">
        <div className="index-banner">
          <div className="index-welcome-banner">
            Full Stack Software Engineer and Designer
          </div>
          <div className="index-welcome-text">
            My name is Dillon Dick, and I focus my efforts in designing user and
            designer friendly experiences in all areas.
          </div>
        </div>
        <div className="index-cards">
          <div className="row">

            {/* <div className="mt-5 col-12 col-md-4">
              <CareerPanel />
            </div> */}
            <div className="mt-5 col-12 col-lg-4 col-md-6 offset-lg-2">
              <GamingPanel />
            </div>
            <div className="mt-5 col-12 col-lg-4 col-md-6">
              <ExperiencesPanel />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
